import * as TYPES from "../../consts/actionsTypes";
import { CookieHandler as CookieManager } from "../../handlers";
const CookieHandler = new CookieManager(true);

const cookie = CookieHandler.getJSON(TYPES.COOKIEBAR_COOKIE);

const initialState = {
  accepted: cookie ? cookie.accepted : false,
  set: cookie ? cookie.set : false,
  clear: cookie ? cookie.clear : false,
  setOnce: false
};

export const cookiebar = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.COOKIEBAR_COOKIE__SET: {
      const { accepted } = action;
      return {
        ...state,
        accepted: accepted,
        set: true,
        clear: false,
        setOnce: true
      };
    }
    case TYPES.COOKIEBAR_COOKIE__CLEARALL: {
      return {
        ...state,
        accepted: false,
        set: false,
        clear: true,
      };
    }
    default:
      return state;
  }
};
